import React, { useState } from "react"
import {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Input,
	UncontrolledButtonDropdown,
} from "reactstrap"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import { getHalftimeCharacter } from "../../utility/Utils"

function EditTimeComponent({
	initialTime,
	initialQuarter,
	time,
	setTime,
	quarter,
	setQuarter,
	setHasError,
}) {
	const { overtimeMinutes, numOfHalftimes } = getSportsConfig(
		localStorage.getItem("sport")
	)
	const quarterOptions = getQuarterOptions(numOfHalftimes)
	const [error, setError] = useState()

	const onTimeChange = ({ target }) => {
		const formattedTime = target.value.replace(/\D/g, "")
		if (formattedTime.length < 5) {
			if (formattedTime.length > 2) {
				setTime(formattedTime.substr(0, 2) + ":" + formattedTime.substr(2))
			} else {
				setTime(formattedTime)
			}
		}
		if (formattedTime.length === 4) {
			checkForErrors(
				formattedTime.substr(0, 2) + ":" + formattedTime.substr(2, 2)
			)
		} else if (formattedTime.length === 0) {
			setHasError(false)
		} else if (formattedTime.length < 4) {
			setHasError(true)
		}
	}

	const checkForErrors = (timeToCheck) => {
		if (timeToCheck.length === 0) {
			setError()
			setHasError(false)
			return
		}
		if (timeToCheck.length !== 5) {
			setError("Vrijeme mora imati 4 broja. (npr. 00:00)")
			setHasError(true)
			return
		}
		if (parseInt(timeToCheck.substr(3)) > 59) {
			setError("Sekunde nemogu bit iznad 59")
			setHasError(true)
			return
		}

		if (quarter.substr(quarter.length - 1, 1) === "Q") {
			const halftime = localStorage.getItem("halftime")
			const quarterNum = parseInt(quarter)
			const minTime =
				numOfHalftimes * halftime + (quarterNum - 1) * overtimeMinutes
			const maxTime = numOfHalftimes * halftime + quarterNum * overtimeMinutes
			if (
				maxTime <= parseInt(timeToCheck) ||
				minTime > parseInt(timeToCheck)
			) {
				setHasError(true)
				setError(
					`Vrijeme za produžetak mora bit ispod ${overtimeMinutes} minut${
						overtimeMinutes > 4 || overtimeMinutes == 1 ? "a" : "e"
					}`
				)
			} else {
				setHasError(false)
				setError()
			}
		} else {
			const halftime = localStorage.getItem("halftime")
			const quarterNum = parseInt(quarter)
			const minTime = (quarterNum - 1) * halftime
			const maxTime = quarterNum * halftime
			if (
				maxTime <= parseInt(timeToCheck) ||
				minTime > parseInt(timeToCheck)
			) {
				setHasError(true)
				setError(`Vrijeme mora bit između ${minTime} i ${maxTime} minute`)
			} else {
				setHasError(false)
				setError()
			}
		}
	}

	const onChangeQuarter = (option) => {
		setQuarter(option)
		if (option.substr(quarter.length - 1, 1) === "Q") {
			const halftime = localStorage.getItem("halftime")
			const quarterNum = parseInt(option)
			const minTime =
				numOfHalftimes * halftime + (quarterNum - 1) * overtimeMinutes
			const maxTime = numOfHalftimes * halftime + quarterNum * overtimeMinutes
			if (maxTime <= parseInt(time) || minTime > parseInt(time)) {
				setTime(
					`${(minTime + "").length === 1 ? `0${minTime}` : minTime}:00`
				)
			}
		} else {
			const halftime = localStorage.getItem("halftime")
			const quarterNum = parseInt(option)
			const minTime = (quarterNum - 1) * halftime
			const maxTime = quarterNum * halftime
			if (maxTime <= parseInt(time) || minTime > parseInt(time)) {
				setTime(
					`${(minTime + "").length === 1 ? `0${minTime}` : minTime}:00`
				)
			}
		}
	}

	return (
		<>
			<p>Dio utakmice</p>
			<UncontrolledButtonDropdown size="md">
				<DropdownToggle color="primary" caret outline>
					{quarter || initialQuarter}
				</DropdownToggle>
				<DropdownMenu>
					{quarterOptions.map((option, index) => (
						<DropdownItem
							key={`quarterOption-${index}`}
							onClick={() => onChangeQuarter(option)}
						>
							{option}
						</DropdownItem>
					))}
				</DropdownMenu>
			</UncontrolledButtonDropdown>
			{(quarter || initialQuarter) !== "P" && (
				<>
					<p>Vrijeme</p>
					<div>
						<Input
							type="text"
							placeholder={initialTime}
							value={time}
							onChange={onTimeChange}
							onBlur={() => checkForErrors(time)}
							onFocus={() => setError()}
							invalid={!!error}
						/>
						<cite>{error}</cite>
					</div>
				</>
			)}
		</>
	)
}

export default EditTimeComponent

// * Helper functions
const getQuarterOptions = (numOfHalftimes) => {
	const isDone =
		localStorage.getItem("penaltiesOrEnd") == "end" ||
		localStorage.getItem("penaltiesOrEnd") == "penalties" ||
		localStorage.getItem("penaltiesOrEnd") == "done" ||
		localStorage.getItem("penaltiesOrEnd") == "forfeit"

	const { overtime, halftime } = JSON.parse(localStorage.getItem("time") ?? "{}")
	const halftimeLetter = getHalftimeCharacter()
	const maxLength = isDone ? numOfHalftimes : parseInt(halftime)
	const toReturn = []
	if (overtime) {
		for (let i = overtime; i > 0; i--) {
			toReturn.push(i + "O")
		}
	}

	for (let i = maxLength; i > 0; i--) {
		toReturn.push(i + halftimeLetter)
	}

	return toReturn
}
